var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "5c4881d38e7eea84f74c6157fdfaee467ecfd9fe"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["dfh-corp-sites@designs-for-health"] = {
  id: "5c4881d38e7eea84f74c6157fdfaee467ecfd9fe"
};